var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"flip-arrow"},[_c('div',{staticClass:"flip-arrow__collapse",on:{"click":function($event){return _vm.$emit('click', $event)}}},[(!_vm.isExpanded)?_c('div',{staticClass:"arrow-up arrow-up--has-hover arrow-up--large"}):_c('div',{staticClass:"arrow-down arrow-down--has-hover arrow-down--large"})])])
}
var staticRenderFns = []

export { render, staticRenderFns }